import Marionette from 'backbone.marionette';
import Radio from 'backbone.radio';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import Api from '@/lib/api/api';
import template from '@/../templates/dialogs/confirm-and-pay.hbs';

var ConfirmAndPayDialog = Marionette.View.extend(DialogInterface).extend({
    template: Handlebars.compile(template),
    ui: {
        add_credit: '#add_credit',
        current_amount_due: '#current_amount_due',
        submit_payment: 'button[type=submit]',
    },
    events: {
        'keyup @ui.add_credit': 'handle_add_credit_change',
        'paste @ui.add_credit': 'handle_add_credit_change',
        'change @ui.add_credit': 'handle_add_credit_change',
        'mouseup @ui.add_credit': 'handle_add_credit_change',
        'click @ui.submit_payment': 'handle_submit_payment',
    },
    initialize: function (options, cards) {
        // cards initialized in controller and passed to the view
        this.cards = cards;
        this.destroyOnClose();
        this.focusFirstInput();
    },
    onRender: function() {
        this.handle_add_credit_change();
    },
    templateContext: function(){
        return {
            card_icon: this.cards[this.getOption('card_type')] || false,
            last_four: this.getOption('card_last4'),
            current_amount_due: this.calculate_amount_due(this.getOption('balance')),
        };
    },
    calculate_amount_due: function(current_balance){
        let balance;
        if (current_balance < 0) {
            balance = Math.abs(current_balance);
            balance = Number(balance).toFixed(2);
            return Math.abs(balance);
        }
        return Number(0).toFixed(2);
    },
    handle_add_credit_change: function(){
        let valid = Number(this.ui.add_credit.val()) > 0;
        valid ? this.ui.submit_payment.prop('disabled', false) : this.ui.submit_payment.prop('disabled', true);
    },
    handle_submit_payment: function(e){
        const globalCh = Radio.channel('global');
        const primary = globalCh.request('primary_account');
        e.preventDefault();
        this.submit_payment(Number(this.ui.add_credit.val()))
            .then(()=>{
                this.closeDialog();
                globalCh.request('show_billing', primary);
                Radio.request('alerts', 'showAlert', {
                    message: `Successfully made payment $${this.ui.add_credit.val()} USD to account ${primary.get('username')} (ID ${primary.id}`,
                    messageType: 'success'
                });
            })
            .catch((response)=>{
                console.error(response);
                const errorText = response && response.responseJSON && response.responseJSON.errors.length && response.responseJSON.errors[0].detail;
                this.showAlert('alert-danger', errorText);
            });
    },
    submit_payment: function(amount){
        return Api.ajax({
            url: Api.urls.payment(),
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({
                "amount_usd": amount,
            })
        });
    }

});
export default ConfirmAndPayDialog;

